import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "booking-view d-flex fl-col"
};
var _hoisted_2 = {
  class: "booking-steps"
};
var _hoisted_3 = {
  key: 0,
  class: "d-flex fl-s-b"
};
var _hoisted_4 = {
  class: "booking-left-side"
};
var _hoisted_5 = {
  class: "booking-right-side d-flex fl-col fl-j-e"
};
var _hoisted_6 = {
  class: "d-flex"
};

var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "custom-loading"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "circular",
  viewBox: "-10, -10, 50, 50"
}, [/*#__PURE__*/_createElementVNode("path", {
  class: "path",
  d: "\n                    M 30 15\n                    L 28 17\n                    M 25.61 25.61\n                    A 15 15, 0, 0, 1, 15 30\n                    A 15 15, 0, 1, 1, 27.99 7.5\n                    L 15 15\n                  ",
  style: {
    "stroke-width": "4px",
    "fill": "rgba(0, 0, 0, 0)"
  }
})])], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_GridsListing = _resolveComponent("GridsListing");

  var _component_Payment = _resolveComponent("Payment");

  var _component_CompleteOrder = _resolveComponent("CompleteOrder");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.step === _ctx.BookingStep.Order ? (_openBlock(), _createBlock(_Suspense, {
    key: 0
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_GridsListing)];
    }),
    _: 1
  })) : _createCommentVNode("", true), _ctx.step === _ctx.BookingStep.Payment || _ctx.step === _ctx.BookingStep.Refund || _ctx.step === _ctx.BookingStep.Discount || _ctx.step === _ctx.BookingStep.Promocode || _ctx.step === _ctx.BookingStep.PromocodeCampaigns ? (_openBlock(), _createBlock(_component_Payment, {
    key: 1
  })) : _createCommentVNode("", true), _ctx.step === _ctx.BookingStep.CompleteOrder ? (_openBlock(), _createBlock(_component_CompleteOrder, {
    key: 2,
    compareTwoObjects: _ctx.compareTwoObjects,
    buildPatchBookingPayload: _ctx.buildPatchBookingPayload
  }, null, 8, ["compareTwoObjects", "buildPatchBookingPayload"])) : _createCommentVNode("", true)]), _ctx.step !== _ctx.BookingStep.CompleteOrder ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [!_ctx.isAcompteBooking && (_ctx.step === _ctx.BookingStep.Payment || _ctx.step === _ctx.BookingStep.Discount || _ctx.step === _ctx.BookingStep.Promocode || _ctx.step === _ctx.BookingStep.PromocodeCampaigns) ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "w-100 booking-button f-bold back-button mb-10",
    onClick: _ctx.goBack
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.back-to-order")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [!_ctx.IsEditOrder ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    size: "large",
    type: "danger",
    class: "w-100 booking-button f-bold",
    disabled: !_ctx.hasTickets,
    onClick: _ctx.cancelOrder
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel-order")), 1)];
    }),
    _: 1
  }, 8, ["disabled", "onClick"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
    size: "large",
    type: "primary",
    class: "w-100 booking-button f-bold",
    disabled: !_ctx.isEnabled1,
    loading: _ctx.isLoading,
    onClick: _ctx.startProcessing
  }, {
    loading: _withCtx(function () {
      return [_hoisted_7];
    }),
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.bookingButtonText) + " ", 1)];
    }),
    _: 1
  }, 8, ["disabled", "loading", "onClick"])]), _createElementVNode("div", null, [_ctx.showSyncButton && (_ctx.step === _ctx.BookingStep.Payment || _ctx.step === _ctx.BookingStep.Refund || _ctx.step === _ctx.BookingStep.Discount || _ctx.step === _ctx.BookingStep.Promocode || _ctx.step === _ctx.BookingStep.PromocodeCampaigns) ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    size: "large",
    type: "warning",
    class: "w-100 booking-button f-bold mt-10",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.confirmSyncPartiallyPaidBooking();
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.complete-order-with-balance")), 1)];
    }),
    _: 1
  })) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]);
}